import { StepType, useTour } from '@reactour/tour';
import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';

const useGetHowToQuickCreateLeadSteps = () => {
  const { setIsOpen, setSteps, setCurrentStep } = useTour();

  const quickCreateLeadSteps: StepType[] = [
    {
      content:
        'Click on the + Create button at the upper left corner of your screen.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.GENERAL_CREATE.CREATE}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 300);
          },
          false,
        );
      },
    },
    {
      content: 'Click on the Create Lead option.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.GENERAL_CREATE.LEAD}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 300);
          },
          false,
        );
      },
    },
    {
      content: (props) => (
        <Content
          {...props}
          content={
            "Fill out the form with the lead's information, such as name, and email."
          }
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.LEAD.FORM.GENERAL.FORM}"]`,
      highlightedSelectors: [
        '[data-tut="global_create_panel_header"]',
        `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.LEAD.FORM.GENERAL.FORM}"]`,
      ],
      position: 'left',
      stepInteraction: false,
      padding: {
        wrapper: [22, 0],
      },
    },
    {
      content: 'Click Save and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.LEAD.FORM.GENERAL.SAVE_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setCurrentStep(0);
            setSteps?.([]);
          },
          false,
        );
      },
      position: 'top',
    },
  ];

  const showQuickCreateLeadSteps = () => {
    setTimeout(() => {
      setSteps?.(quickCreateLeadSteps);
      setIsOpen(true);
    }, 300);
  };

  return showQuickCreateLeadSteps;
};

export default useGetHowToQuickCreateLeadSteps;
